/**
 * General JS
 *
 */

import Swal from 'sweetalert2';

window.General = new (function() {

    const that = this;

    this.init = function (){

        //show change room
        $('.create-cut-box').on('click', that.createCutBox);

        //close any swal
        $(document).on('click', '.close-any-swal', function () {
            Swal.resetValidationMessage();
            Swal.close();
        });

    };


    /**
     * Check tickets
     */
    this.createCutBox = function () {
        Swal.fire({
            html: cutBoxHTML,
            showCloseButton: false,
            showCancelButton: false,
            showConfirmButton: false,
            customClass: "wrap-add-product-service new-room",
            didOpen: () => {
                // Evento dentro del Swal, después de que se renderiza
                $(document).off('click', '.create-cut-box').on('click', '.create-cut-box', function () {

                    let cutBoxTitle = $('#cut-box-concept').val();
                    let cutBoxQuantity = $('#cut-box-quantity').val();
                    let cutBoxWhoReceive = $('#cut-box-name').val();
                    let cutBoxRecurringMaintenance = $('#cut-box-recurring-maintenance').val();
                    let cutBoxRecurringMaintenanceDone = $('#cut-box-recurring-maintenance-done').val();

                    console.log(!cutBoxTitle.trim(), !cutBoxQuantity.trim());

                    if (!cutBoxTitle.trim() || !cutBoxQuantity.trim()) {
                        Swal.showValidationMessage('Los campos "Concepto" e "Importe" son obligatorios');
                        return;
                    }

                    // Aquí puedes continuar con el envío de datos
                    that.saveCutBox(cutBoxTitle, cutBoxWhoReceive, cutBoxQuantity, cutBoxRecurringMaintenance, cutBoxRecurringMaintenanceDone);
                    Swal.resetValidationMessage();
                    Swal.close(); // Cierra el Swal si todo está bien
                });
            }
        });
    };

    /**
     * Save cut vox
     */
    this.saveCutBox = function (cutBoxTitle, cutBoxWhoReceive, cutBoxQuantity, cutBoxRecurringMaintenance, cutBoxRecurringMaintenanceDone) {

        //ajax settings
        var settings = {
            url: cutBoxRoute,
            method: "POST",
            data: {
                _token: $(document)
                    .find('meta[name="csrf-token"]')
                    .attr("content"),
                'concept' : cutBoxTitle,
                'who_receive' : cutBoxWhoReceive,
                'import' : cutBoxQuantity,
                'recurring_maintenance_id' : cutBoxRecurringMaintenance,
                'recurring_maintenance_done' : cutBoxRecurringMaintenanceDone,
            },
        };

        //ajax call
        $.ajax(settings)
            .done(function (response) {

                Swal.fire({
                    icon: 'success',
                    title: '¡Guardado exitosamente!',
                    text: 'El corte de caja fue creado correctamente.',
                    confirmButtonText: 'Aceptar',
                    timer: 4000,
                    showConfirmButton: false
                });


                // Abrir nueva pestaña con la URL deseada
                window.open(cutBoxPrint + '/' + response, '_blank');

            })
            .fail(function (xhr, status, error) {
                console.log('Error al intentar crear el corte de caja');
                console.log(error);

                Swal.fire({
                    icon: 'error',
                    title: 'Ocurrió un error',
                    text: 'No se pudo guardar el corte de caja.',
                    confirmButtonText: 'Aceptar'
                });
            });
    };

})();
